import request from '../utils/request'

//请求用户信息
export default {
    //获取用户操作权限
    getUserInfo({account}) {
        return request({
          method: 'GET',
          url: `/person/selPersonDetail?keywordType=1&searchKeyword=${account}`
        })
	},
	//查询所有部门
	getAllDept(deptId) {
		return request({
			method: "GET",
			url: `/org/getAllDept?deptId=${deptId}`
		})
	},
	//搜索部门
	getDepartment({ deptName, pageNo, pageSize }) {
		return request({
			method: "GET",
			url: `/org/getDepartment?deptName=${deptName}&pageNo=${pageNo}&pageSize=20`
		})
	}
}